//
//
//
//
//
//
//
//
//

export default {
  name: 'no-found-component',
  methods: {
    goBack() {
      if (this.back) {
        console.log('this.back', this.back);
        this.$router.push(this.back);
      } else {
        if (window.history.length >= 1) {
          this.$router.go(-1);
        } else {
          this.$router.replace('/');
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/NoFound.vue